import { FormPath } from "@/Common/Models/Forms/FormPath";
import { ElementType, FormElement } from "@/Common/Models/Forms/FormTemplateInterfaces";
import { QuestionnaireAnswer } from "@/Common/Models/Questionnaires/QuestionnaireAnswer";
import { ComponentRenderer } from "../ComponentRenderer";

abstract class ElementRenderer extends ComponentRenderer {
    constructor(element: FormElement, answers: QuestionnaireAnswer[]) {
        super(element, answers);
    }

    protected areAnswersOfComponent(formPath: string): boolean {
        const currentComponentFormPath = new FormPath(this.component.FormPath);
        const answerFormPath = new FormPath(formPath);
        return currentComponentFormPath.elementNumber === answerFormPath.elementNumber;
    }

    public abstract get propertyName(): string;
    public abstract get elementType(): ElementType;
    public abstract isValid(): boolean;

    public render(onChange?: (answer: QuestionnaireAnswer) => void, disabled?: boolean): JSX.Element {
        return (
            <div key={this.component.InternalName} className="container-fluid" style={{ padding: "10px" }}>
                <div className="row">
                    {this.renderQuestion()}
                </div>
                <div className="row" style={{ padding: "10px" }}>
                    {this.renderAnswer(onChange, disabled)}
                </div>
            </div>
        );
    }

    protected renderQuestion(): JSX.Element {
        const question: string = this.component.getComponentName();

        return (
            <p style={{ whiteSpace: "pre-wrap", fontWeight: "bold" }}>
                <span>{this.component.Position + 1}.</span> {question.removeMarkdown()}
            </p>
        );
    }

    protected abstract renderAnswer(onChange?: (answer: QuestionnaireAnswer) => void, disabled?: boolean): JSX.Element;
}

export { ElementRenderer };
